import { Controller } from "@hotwired/stimulus"
import ValueParser from "../../utils/value_parser"
import PercentService from "../../utils/percent_service"

// Connects to data-controller="tracker--segment_adj"
export default class extends Controller {
  static targets = [
    'segmentsTotal', 'pledgedSegment', 'unpledgedSegment',
    'newSegment'
  ]

  connect() {
    app.tracker_segment_adjs ??= []
    app.tracker_segment_adjs.push(this)
  }

  updateSegmentsTotal() {
    let total = this.calculateSegmentsTotal()
    this.segmentsTotalTarget.innerText = total + '%'

    if (total != 100) {
      this.segmentsTotalTarget.classList.add('text-red-500')
    } else {
      this.segmentsTotalTarget.classList.remove('text-red-500')
    }
  }

  calculateSegmentsTotal() {
    let total = 0

    this.segmentInputs.forEach((input) => {
      let value = parseFloat(input.value, 10)

      if (!isNaN(value)) {
        total += value
      }
    })

    return total.toFixed(2)
  }

  get segmentInputs() {
    return [
      this.pledgedSegmentTarget,
      this.unpledgedSegmentTarget,
      this.newSegmentTarget
    ]
  }
}
